import {
  UNIT_SAVE_UNIT_BEGIN,
  UNIT_SAVE_UNIT_SUCCESS,
  UNIT_SAVE_UNIT_FAILURE,
  UNIT_SAVE_UNIT_DISMISS_ERROR,
} from './constants';

import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveUnit(unit, action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: UNIT_SAVE_UNIT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/units';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        unit.unit = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }

      axios.post(URL, {
        unit:unit
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            dispatch({
              type: UNIT_SAVE_UNIT_SUCCESS,
              data: res,
              action_model:action
            });
            resolve(res);
          }else
          {
            dispatch({
              type: UNIT_SAVE_UNIT_FAILURE,
              data: { error: "Internal Error" },
              action_model:action
            });
            reject("Internal Error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: UNIT_SAVE_UNIT_FAILURE,
            data: { error: err },
            action_model:action
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveUnitError() {
  return {
    type: UNIT_SAVE_UNIT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case UNIT_SAVE_UNIT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveUnitPending: true,
        saveUnitError: null,
      };

    case UNIT_SAVE_UNIT_SUCCESS:
    let fragmentContent = "The unit has been updated with success!";
      let fragmentTitle = "Update Unit";
      let paperTitle = "Update Unit";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        fragmentContent='The unit has been created with success!'
        fragmentTitle='Create Unit'
        paperTitle='Create Unit'
      }
      // The request is success
      return {
        ...state,
        saveUnitPending: false,
        saveUnitError: null,
        savePending:false,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
      };

    case UNIT_SAVE_UNIT_FAILURE:
      // The request is failed
      // The request is failed
      let fragmentContentFail = "We found an error";
      let fragmentTitleFail = "Update Unit";
      let paperTitleFail = "Update Unit";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The unit has not been created with success!'
        fragmentTitleFail='Create Unit'
        paperTitleFail='Create Unit'
      }
      return {
        ...state,
        saveUnitPending: false,
        saveUnitError: action.data.error,
        savePending:false,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
      };

    case UNIT_SAVE_UNIT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveUnitError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/unit/redux/saveUnit.js